import { useTranslation } from 'react-i18next';
import SpeechBubble from '../../FirstAid/components/SpeechBubble/SpeechBubble';
import mascot from '../../../assets/kitoBuddy/Celebration.png';
import CustomButton from '../../../components/CustomButton';

export default function Congratulations({ title, CTA, path }) {
  const { t } = useTranslation();
  const handleNavigate = () => {
    window.location.href = t(path);
  };
  return (
    <div className="congrats">
      <SpeechBubble mascot={mascot} text={t(title)} />
      <CustomButton label={t(CTA)} className="congrats__button" onClick={handleNavigate} />
    </div>
  );
}
